// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__ATxnv","rcSwitchOff":"Switch_rcSwitchOff__3E6EP","rcSwitchOn":"Switch_rcSwitchOn__2A76B","none":"Switch_none__28fgu","rotating":"Switch_rotating__2xjjL"};